export enum CONFIGURATIONS_FORM_FIELDS {
	LIMIT_INTERVAL = 'LimitInterval',
	LIMIT_COUNT = 'LimitCount',
	MAX_PER_DAY = 'MaxPerDay',
	// GHOST_PERCENTAGE = 'GhostModeThrottlePercentage',
	THROTTLE_PERCENTAGE = 'ThrottlePercentage',
	MAXIMUM_ORDERS = 'Maximum orders',
	// NFS_DECLINE_THROTTLING = 'offer_NSF_RequestsThrottle_Percentage',
	AGREED_EXPIRY_DATE_MIT = 'mitAgreedExpiryHours',
	MIN_ORDER_AMOUNT = 'minOrderAmount',
	MAX_ORDER_AMOUNT = 'maxOrderAmount',
	// DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE = 'dynamicAuthorizationDiscountThrottlePercentage',
	RISK_LEVEL = 'riskLevel',
	RISK_LEVEL_VISA = 'riskLevel_Visa',
	RISK_TIER = 'riskTier',
}

export enum CONFIGURATIONS_FORM_FIELDS_NAMES {
	// GHOST_PERCENTAGE = 'CONFIGURATIONS.GHOST_PERCENTAGE',
	// GHOST_PERCENTAGE_DESCRIPTION = 'CONFIGURATIONS.GHOST_PERCENTAGE_DESCRIPTION',
	THROTTLE_PERCENTAGE = 'CONFIGURATIONS.THROTTLE_PERCENTAGE',
	// DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE = 'CONFIGURATIONS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE',
	THROTTLE_PERCENTAGE_DESCRIPTION = 'CONFIGURATIONS.THROTTLE_PERCENTAGE_DESCRIPTION',
	MAX_PER_DAY = 'CONFIGURATIONS.MAX_PER_DAY',
	MAX_PER_DAY_DESCRIPTION = 'CONFIGURATIONS.MAX_PER_DAY_DESCRIPTION',
	LIMIT_COUNT = 'CONFIGURATIONS.LIMIT_COUNT',
	LIMIT_COUNT_DESCRIPTION = 'CONFIGURATIONS.LIMIT_COUNT_DESCRIPTION',
	PER = 'CONFIGURATIONS.PER',
	LIMIT_INTERVAL = 'CONFIGURATIONS.LIMIT_INTERVAL',
	MAXIMUM_ORDERS = 'CONFIGURATIONS.MAXIMUM_ORDERS',
	MAXIMUM_ORDERS_DESCRIPTION = 'CONFIGURATIONS.MAXIMUM_ORDERS_DESCRIPTION',
	// NFS_DECLINE_THROTTLING = 'CONFIGURATIONS.NFS_DECLINE_THROTTLING',
	// NFS_DECLINE_THROTTLING_DESCRIPTION = 'CONFIGURATIONS.NFS_DECLINE_THROTTLING_DESCRIPTION',
	AGREED_EXPIRY_DATE_MIT = 'CONFIGURATIONS.AGREED_EXPIRY_DATE_MIT',
	AGREED_EXPIRY_DATE_MIT_DESCRIPTION = 'CONFIGURATIONS.AGREED_EXPIRY_DATE_MIT_DESCRIPTION',
	MIN_ORDER_AMOUNT = 'CONFIGURATIONS.MIN_ORDER_AMOUNT',
	MIN_ORDER_AMOUNT_DESCRIPTION = 'CONFIGURATIONS.MIN_ORDER_AMOUNT_DESCRIPTION',
	MAX_ORDER_AMOUNT = 'CONFIGURATIONS.MAX_ORDER_AMOUNT',
	MAX_ORDER_AMOUNT_DESCRIPTION = 'CONFIGURATIONS.MAX_ORDER_AMOUNT_DESCRIPTION',
	RISK_LEVEL = 'CONFIGURATIONS.RISK_LEVEL',
	RISK_LEVEL_VISA = 'CONFIGURATIONS.RISK_LEVEL_VISA',
	RISK_TIER = 'CONFIGURATIONS.RISK_TIER',
	RISK_TIER_DESCRIPTION = 'CONFIGURATIONS.RISK_TIER_DESCRIPTION',
}

export type ConfigurationsFieldsType = {
	[CONFIGURATIONS_FORM_FIELDS.LIMIT_INTERVAL]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.LIMIT_COUNT]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.MAX_PER_DAY]: number | string | null,
	// [CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.MAXIMUM_ORDERS]: number | string | null,
	// [CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.AGREED_EXPIRY_DATE_MIT]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.MIN_ORDER_AMOUNT]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.MAX_ORDER_AMOUNT]: number | string | null,
	// [CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE]: number | string | null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL]: number | null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL_VISA]: number | null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_TIER]: string,
}

export type ConfigurationsFieldsReturnType = {
	offerRequestsRateLimitIntervalMS: number | string,
	offerRequestsRateLimitCount: number | string,
	offerRequestsMaxPerDay: number | string,
	// ghostModeThrottlePercentage: number | string,
	offerRequestsThrottlePercentage: number | string | null,
	orders_MaxMonthlyAmount: number | string | undefined,
	// offer_NSF_RequestsThrottle_Percentage: number | string | undefined,
	// dynamicAuthorizationDiscountThrottlePercentage: number | string | undefined,
	mitAgreedExpiryHours: number | string | undefined,
	minOrderAmount: number | string | undefined,
	maxOrderAmount: number | string | undefined,
	riskLevel: number | null,
	riskLevel_Visa: number | null,
	riskTier: string | number,
}

export const initialConfigurations: ConfigurationsFieldsType = {
	[CONFIGURATIONS_FORM_FIELDS.LIMIT_INTERVAL]: '',
	[CONFIGURATIONS_FORM_FIELDS.LIMIT_COUNT]: '',
	[CONFIGURATIONS_FORM_FIELDS.MAX_PER_DAY]: '',
	// [CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE]: 100,
	[CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE]: '',
	[CONFIGURATIONS_FORM_FIELDS.MAXIMUM_ORDERS]: '',
	// [CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING]: '',
	[CONFIGURATIONS_FORM_FIELDS.AGREED_EXPIRY_DATE_MIT]: '',
	[CONFIGURATIONS_FORM_FIELDS.MIN_ORDER_AMOUNT]: '',
	[CONFIGURATIONS_FORM_FIELDS.MAX_ORDER_AMOUNT]: '',
	// [CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE]: '',
	[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL]: null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL_VISA]: null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_TIER]: '',
};

export const getFormattedConfigurations = (formikValues): ConfigurationsFieldsReturnType => ({
	offerRequestsRateLimitIntervalMS: formikValues?.[CONFIGURATIONS_FORM_FIELDS.LIMIT_INTERVAL],
	offerRequestsRateLimitCount: formikValues?.[CONFIGURATIONS_FORM_FIELDS.LIMIT_COUNT],
	offerRequestsMaxPerDay: formikValues?.[CONFIGURATIONS_FORM_FIELDS.MAX_PER_DAY],
	// ghostModeThrottlePercentage : formikValues?.[CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE] && (formikValues?.[CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE] / 100),
	offerRequestsThrottlePercentage: formikValues?.[CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE] && (formikValues?.[CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE] / 100),
	// dynamicAuthorizationDiscountThrottlePercentage: formikValues?.[CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE] && (formikValues?.[CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE] / 100),
	orders_MaxMonthlyAmount: formikValues?.[CONFIGURATIONS_FORM_FIELDS.MAXIMUM_ORDERS],
	// offer_NSF_RequestsThrottle_Percentage: formikValues?.[CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING] && (formikValues?.[CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING] / 100),
	mitAgreedExpiryHours: formikValues?.[CONFIGURATIONS_FORM_FIELDS.AGREED_EXPIRY_DATE_MIT],
	minOrderAmount: formikValues?.[CONFIGURATIONS_FORM_FIELDS.MIN_ORDER_AMOUNT],
	maxOrderAmount: formikValues?.[CONFIGURATIONS_FORM_FIELDS.MAX_ORDER_AMOUNT],
	riskLevel: formikValues?.[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL],
	riskLevel_Visa: formikValues?.[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL_VISA],
	riskTier: formikValues?.[CONFIGURATIONS_FORM_FIELDS.RISK_TIER] ? Number(formikValues?.[CONFIGURATIONS_FORM_FIELDS.RISK_TIER]) : null,
});

export const convertConfigurationsToInitial = (data): ConfigurationsFieldsType => ({
	[CONFIGURATIONS_FORM_FIELDS.LIMIT_INTERVAL]: data?.offerRequestsRateLimitIntervalMS ? data.offerRequestsRateLimitIntervalMS : 0,
	[CONFIGURATIONS_FORM_FIELDS.LIMIT_COUNT]: data?.offerRequestsRateLimitCount ? data.offerRequestsRateLimitCount : 0,
	[CONFIGURATIONS_FORM_FIELDS.MAX_PER_DAY]: data?.offerRequestsMaxPerDay ? data.offerRequestsMaxPerDay : 0,
	// [CONFIGURATIONS_FORM_FIELDS.GHOST_PERCENTAGE]: typeof data?.ghostModeThrottlePercentage === 'number' ? (data?.ghostModeThrottlePercentage * 100) : 100,
	[CONFIGURATIONS_FORM_FIELDS.THROTTLE_PERCENTAGE]: data?.offerRequestsThrottlePercentage ? (data?.offerRequestsThrottlePercentage * 100) : 0,
	// [CONFIGURATIONS_FORM_FIELDS.DYNAMIC_AUTHORIZATION_DISCOUNT_THROTTLE_PERCENTAGE]: data?.dynamicAuthorizationDiscountThrottlePercentage ? (data?.dynamicAuthorizationDiscountThrottlePercentage * 100) : 0,
	[CONFIGURATIONS_FORM_FIELDS.MAXIMUM_ORDERS]: typeof data?.orders_MaxMonthlyAmount === 'number' ? data.orders_MaxMonthlyAmount : null,
	// [CONFIGURATIONS_FORM_FIELDS.NFS_DECLINE_THROTTLING]: typeof data?.offer_NSF_RequestsThrottle_Percentage === 'number' ? (data.offer_NSF_RequestsThrottle_Percentage * 100) : null,
	[CONFIGURATIONS_FORM_FIELDS.AGREED_EXPIRY_DATE_MIT]: data?.mitAgreedExpiryHours ? data.mitAgreedExpiryHours : 0,
	[CONFIGURATIONS_FORM_FIELDS.MIN_ORDER_AMOUNT]: data?.minOrderAmount ? data.minOrderAmount : 0,
	[CONFIGURATIONS_FORM_FIELDS.MAX_ORDER_AMOUNT]: data?.maxOrderAmount ? data.maxOrderAmount : 0,
	[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL]: data?.riskLevel ? data.riskLevel : null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_LEVEL_VISA]: data?.riskLevel_Visa ? data.riskLevel_Visa : null,
	[CONFIGURATIONS_FORM_FIELDS.RISK_TIER]: data?.riskTier ? data.riskTier.toString() : '',
});

export const getFormattedConfigurationData = (data): ConfigurationsFieldsReturnType => ({
	offerRequestsRateLimitIntervalMS: data.offerRequestsRateLimitIntervalMS,
	offerRequestsRateLimitCount: data.offerRequestsRateLimitCount,
	offerRequestsMaxPerDay: data.offerRequestsMaxPerDay,
	// ghostModeThrottlePercentage : data.ghostModeThrottlePercentage,
	offerRequestsThrottlePercentage: data.offerRequestsThrottlePercentage,
	orders_MaxMonthlyAmount: data.orders_MaxMonthlyAmount,
	// offer_NSF_RequestsThrottle_Percentage: data.offer_NSF_RequestsThrottle_Percentage,
	mitAgreedExpiryHours: data.mitAgreedExpiryHours,
	minOrderAmount: data.minOrderAmount,
	maxOrderAmount: data.maxOrderAmount,
	// dynamicAuthorizationDiscountThrottlePercentage: data.dynamicAuthorizationDiscountThrottlePercentage,
	riskLevel: data.riskLevel,
	riskLevel_Visa: data.riskLevel_Visa,
	riskTier: data.riskTier,
});
